import React from "react"
import { Box, Radio, Checkbox, Tooltip } from "@material-ui/core"
import Clock from "react-live-clock"
import moment from "moment"
import { ActionCard } from "."
import { AuthorTools } from "../Author"
import { RowBox } from "../Boxes"
import { Icon } from ".."

const LocationActionCard = ({
  location,
  variant = "normal",
  actionType = "radio",
  checked,
  onChange,
  onEdit,
  onDelete,
  detail,
  ...rest
}) => {
  const { id, name, timeZone, region } = location

  const handleEdit = () => {
    if (onEdit) onEdit(location)
  }
  const handleDelete = () => {
    if (onDelete) onDelete(location)
  }

  // admins={{ edit: "location_update", delete: "location_delete" }}

  return (
    <ActionCard
      key={id}
      title={name}
      cardProps={{ onClick: onChange }}
      cursor={null}
      stub={
        actionType && (
          <Box ml={-1}>
            {actionType === "radio" && <Radio checked={checked} color="primary" onClick={onChange} />}
            {actionType === "checkbox" && <Checkbox checked={checked} color="primary" onClick={onChange} />}
          </Box>
        )
      }
      detail={
        detail ||
        (variant === "compact" && (
          <>
            {timeZone.replace("_", " ")} {moment.tz(timeZone).format("Z")}
          </>
        ))
      }
      rightChildren={
        <AuthorTools
          item={location}
          admins={{ edit: "location_update" }}
          onEdit={handleEdit}
          subject="location"
          onDelete={handleDelete}
        />
      }
      footer={
        variant === "normal" && (
          <>
            <RowBox mr="auto">
              <Tooltip title="Time zone">
                <RowBox>
                  <Icon name="timezone" />
                  <Box ml={1}>{timeZone.replace("_", " ")}</Box>
                </RowBox>
              </Tooltip>
              {region && (
                <Tooltip title="Region">
                  <RowBox ml={3}>
                    <Icon name="region" />
                    <Box ml={1}>{region.name}</Box>
                  </RowBox>
                </Tooltip>
              )}
            </RowBox>

            <RowBox ml="auto">
              <Icon name="clock" />
              <Box ml={1}>
                <Clock timezone={timeZone} ticking format="Do MMM YYYY h:mma z" />
              </Box>
            </RowBox>
          </>
        )
      }
      {...rest}
    />
  )
}

export { LocationActionCard }
